// extracted by mini-css-extract-plugin
export default {"typeAheadChanger":"TypeAhead_typeAheadChanger__2nrKR","typeAheadChangerItem":"TypeAhead_typeAheadChangerItem__XHTWI","typeAheadTitle":"TypeAhead_typeAheadTitle__7lQHV"};